"use strict";

var _toConsumableArray = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _objectSpread = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _slicedToArray = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _taggedTemplateLiteral = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _nullishCoalesce(lhs, rhsFn) {
  if (lhs != null) {
    return lhs;
  } else {
    return rhsFn();
  }
}

var _chunkSSOLMJ6Rjs = require('./chunk-SSOLMJ6R.js');

var _chunkP4KLBECRjs = require('./chunk-P4KLBECR.js');

var _chunk6R5OOOHCjs = require('./chunk-6R5OOOHC.js');

var _styledcomponents = require('styled-components');

var _styledcomponents2 = _interopRequireDefault(_styledcomponents);

var _jsxruntime = require('react/jsx-runtime');

var I = function I(_ref) {
  var e = _ref.children,
      o = _ref.className,
      s = _ref.XL;
  return _jsxruntime.jsx.call(void 0, S, {
    $XL: s,
    className: o,
    children: e
  });
},
    y = exports.b = _styledcomponents.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: grid;\n    grid-column-gap: 24px;\n    grid-template-columns: repeat(12, 1fr);\n\n    ", "\n"])), _chunkP4KLBECRjs.b.call(void 0, "xs", _styledcomponents.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            grid-column-gap: 16px;\n            grid-template-columns: repeat(4, 1fr);\n        "]))))),
    O = exports.c = function (e) {
  var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;

  if (process.env.NODE_ENV !== "production") {
    if (e < 1) throw new Error("Cannot have less than 1 column");
    if (e > 12) throw new Error("Cannot have more than 12 columns");
    if (o && o < 1) throw new Error("Cannot have less than 1 column (mobile)");
    if (o && o > 4) throw new Error("Cannot have more than 4 columns (mobile)");
  }

  return _styledcomponents.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        display: grid;\n        grid-column-gap: 24px;\n        grid-template-columns: repeat(", ", 1fr);\n\n        ", "\n    "])), e, _chunkP4KLBECRjs.b.call(void 0, "xs", _styledcomponents.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n                grid-column-gap: 16px;\n                grid-template-columns: repeat(", ", 1fr);\n            "])), o)));
},
    c = exports.d = _styledcomponents.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    ", "\n    padding: 0 24px;\n    margin: 0 auto;\n    max-width: ", ";\n\n    ", "\n\n    @media print {\n        padding: 0;\n    }\n"])), y, function (_ref2) {
  var e = _ref2.theme;
  return e.breakpoints.mdMax;
}, _chunkP4KLBECRjs.b.call(void 0, "xs", _styledcomponents.css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n            margins: 0 16px;\n\n            > * {\n                grid-column: span 4;\n            }\n        "]))))),
    R = exports.e = _styledcomponents.css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    ", "\n    max-width: ", ";\n"])), c, function (_ref3) {
  var e = _ref3.theme;
  return e.breakpoints.lgMax;
}),
    S = exports.f = _styledcomponents2.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    ", "\n\n    ", "\n\n    > * {\n        grid-column: span 12;\n    }\n\n    ", "\n"])), c, function (_ref4) {
  var e = _ref4.$XL,
      o = _ref4.theme;
  return e && _styledcomponents.css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n            max-width: ", ";\n        "])), o.breakpoints.lgMax);
}, _chunkP4KLBECRjs.b.call(void 0, "xs", _styledcomponents.css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n            > * {\n                grid-column: span 4;\n            }\n        "])))));

var _jotai = require('jotai');

var _react = require('react');

var _usedebounce = require('use-debounce');

var a = _jotai.atom.call(void 0, _chunk6R5OOOHCjs.i && document.body ? document.body.clientHeight : 0),
    i = exports.h = _jotai.atom.call(void 0, _chunk6R5OOOHCjs.i && document.body ? document.body.clientWidth : 0),
    W = exports.i = _jotai.atom.call(void 0, function (e) {
  return e(i) >= _chunkSSOLMJ6Rjs.b.smMinValue;
}),
    g = exports.j = _jotai.atom.call(void 0, function (e) {
  return e(i) <= _chunkSSOLMJ6Rjs.b.xsMaxValue;
}),
    C = exports.k = _jotai.atom.call(void 0, function (e) {
  return e(i) >= _chunkSSOLMJ6Rjs.b.smMinValue && e(i) <= _chunkSSOLMJ6Rjs.b.smMaxValue;
}),
    H = exports.l = _jotai.atom.call(void 0, function (e) {
  return e(i) <= _chunkSSOLMJ6Rjs.b.smMaxValue;
}),
    Q = exports.m = function (_ref5) {
  var e = _ref5.children,
      o = _ref5.defaultHeight,
      s = _ref5.defaultWidth,
      _ref5$windowSizeThrot = _ref5.windowSizeThrottle,
      u = _ref5$windowSizeThrot === void 0 ? 0 : _ref5$windowSizeThrot;

  var t = _jotai.useStore.call(void 0);

  _react.useMemo.call(void 0, function () {
    t.get(a) === 0 && o && t.set(a, o), t.get(i) === 0 && s && t.set(i, s);
  }, []), _react.useEffect.call(void 0, function () {
    t.get(a) !== document.body.clientHeight && document.body.clientHeight !== 0 && t.set(a, document.body.clientHeight), t.get(i) !== document.body.clientWidth && document.body.clientWidth !== 0 && t.set(i, document.body.clientWidth);
  }, [t]);

  var n = _usedebounce.useThrottledCallback.call(void 0, function () {
    t.set(a, document.body.clientHeight), t.set(i, document.body.clientWidth);
  }, u, {
    trailing: !0
  });

  return _react.useEffect.call(void 0, function () {
    return window.addEventListener("resize", n), window.addEventListener("orientationchange", n), function () {
      window.removeEventListener("resize", n), window.removeEventListener("orientationchange", n);
    };
  }, [n]), e;
},
    U = exports.n = function () {
  return _jotai.useAtomValue.call(void 0, W);
},
    f = exports.o = function () {
  return _jotai.useAtomValue.call(void 0, g);
},
    Y = exports.p = function () {
  return _jotai.useAtomValue.call(void 0, C);
},
    Z = exports.q = function () {
  return _jotai.useAtomValue.call(void 0, H);
},
    j = exports.r = function () {
  return _jotai.useAtomValue.call(void 0, a);
},
    ee = exports.s = function () {
  return _jotai.useAtomValue.call(void 0, i);
};

var de = function de(_ref6) {
  var e = _ref6.forceGridHighlight,
      o = _objectWithoutProperties(_ref6, ["forceGridHighlight"]);

  var _react$useState$call = _react.useState.call(void 0, !1),
      _react$useState$call2 = _slicedToArray(_react$useState$call, 2),
      s = _react$useState$call2[0],
      u = _react$useState$call2[1];

  _react.useEffect.call(void 0, function () {
    if (typeof window < "u" && window && (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test")) return window.hui = _nullishCoalesce(window.hui, function () {
      return {};
    }), window.hui.enableGridHighlights = function (n) {
      typeof n == "boolean" && u(n);
    }, function () {
      typeof window < "u" && window.hui && delete window.hui.enableGridHighlights;
    };
  });

  var t = f();
  return s || e ? _jsxruntime.jsx.call(void 0, A, _objectSpread({
    "data-testid": "grid-highlighter"
  }, o, {
    children: _toConsumableArray(Array(t ? 4 : 12).keys()).map(function (n) {
      return _jsxruntime.jsx.call(void 0, "div", {
        "data-testid": "grid-highlighter-column"
      }, n);
    })
  })) : null;
},
    A = exports.u = _styledcomponents2.default.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    ", "\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 100%;\n    background-color: transparent;\n    z-index: 1;\n    pointer-events: none;\n    > div {\n        pointer-events: none;\n        background-color: ", ";\n        opacity: 0.15;\n    }\n"])), c, function (_ref7) {
  var e = _ref7.theme;
  return e.color.text.error;
});

var P = _jotai.atom.call(void 0, function (e) {
  var o = e(i);
  return e(g) ? {
    columnCount: 4,
    columnSize: (o - 16 * 5) / 4,
    gapSize: 16
  } : {
    columnCount: 12,
    columnSize: (Math.min(o, _chunkSSOLMJ6Rjs.b.mdMaxValue) - 24 * 13) / 12,
    gapSize: 24
  };
}),
    ce = exports.v = function () {
  return _jotai.useAtomValue.call(void 0, P);
};

exports.a = I;
exports.b = y;
exports.c = O;
exports.d = c;
exports.e = R;
exports.f = S;
exports.g = a;
exports.h = i;
exports.i = W;
exports.j = g;
exports.k = C;
exports.l = H;
exports.m = Q;
exports.n = U;
exports.o = f;
exports.p = Y;
exports.q = Z;
exports.r = j;
exports.s = ee;
exports.t = de;
exports.u = A;
exports.v = ce;